module.exports = "<div class=\"arrows-container\">\r\n  <div class=\"arrows\"></div>\r\n  <div class=\"arrows arrows2\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/shared/arrows/arrows.component.html
// module id = ../../../../../src/app/shared/arrows/arrows.component.html
// module chunks = main